import './AddContentNode.scss';

import React from 'react';
import BaseNode, { FlowNodeMenuItem } from 'components/FlowBuilder/FlowNodes/BaseNode/BaseNode';
import IconPlus from 'pages/FlowBuilder/assets/icons/IconPlus';

const MAIN_CLASS = 'add-content-node';
const CLASSES = {
  LABEL: `${MAIN_CLASS}__label`,
  LABEL_BUTTON: `${MAIN_CLASS}__label__button`,
  ICON_PLUS: `${MAIN_CLASS}__icon-plus`,
  ICON_PLUS_CONTAINER: `${MAIN_CLASS}__icon-plus-container`,
};

const renderAddContentNode = () => (
  <div className={CLASSES.LABEL}>
    <button className={CLASSES.LABEL_BUTTON} aria-label="Add content">
      <span>+</span>
      Add content(s)
    </button>
  </div>
);

function AddContentNode() {
  const menuItems: FlowNodeMenuItem[] = [];
  // You can add menu actions here if needed in future

  return (
    <BaseNode Icon={IconPlus} menuItems={menuItems} className={MAIN_CLASS}>
      {renderAddContentNode()}
    </BaseNode>
  );
}

export default AddContentNode;
